<template>
    <div class="ideas" v-if="loaded && ready">

      <div class="container hero-idea" :class="{'vis': loaded2}" >

        <div class="controls">
          <h1 >
            {{workData.headline.white[lang].name}}<br>
            {{workData.headline.orange[lang].name}} <br>

          </h1>

          <div class="filters-group" :class="{'vis': loaded2}" >

              <div class="nav-tags-item" v-on:click="setFilterAll" :class="{'active' : filtersActive.length == tags.length}"  >
                <span v-if="lang == 0">Todos</span>
                <span v-if="lang == 1">All</span>
              </div>

              <div class="nav-tags-item" v-for="(item, index) in tags"    :class="{'active' : hasFilter(item) && filtersActive.length < tags.length}" v-on:click="setFilter(item.name[lang].name)" >{{item.name[lang].name}}</div>

          </div>
        </div>



      </div>



      <div class="container">

        <div class="grid-ideas">
          <transition-group name="fade" >
          <a class="grid-iideas-item" v-for="(item, index) in projectsFiltres"
               :key="index"
               :class="[{'grid-ideas-item-large' : index < 4},
               {'grid-ideas-item-normal' : index >= 4},
               {'vis' :  offSet.last >= index}]"
               :href="'project/' + item.route + '?lang=' + langs[lang]"

          >

            <img src="/static/images/ref-img.png" alt="Nossa work" class="ref-img" v-if="offSet.last < index">
            <div class="box-anim">

              <div class="thumb-case">
                <img src="/static/images/empty.png" :alt="item.title[0].name" class="empty">
                <media-type :className="'grid-ideas-media'" :obj="item.cover" :testvid="index" :dynAlt="item.title[0].name" v-if="offSet.last >= index && (!item.cover_amim || !item.hasVideo || !item.cover_amim.vid) || dev == false" :thumb="true" :full="true">  </media-type>
                <media-type :className="'grid-ideas-media'" :obj="item.cover_amim" :testvid="index" :dynAlt="item.title[0].name" v-else :thumb="true" :full="true">  </media-type>


                <!--media-type :className="'grid-ideas-media'" :obj="item.cover_amim" :testvid="index" :dynAlt="item.title[0].name" v-if="offSet.last >= index && item.cover_amim && item.hasVideo" :thumb="true" :full="true">  </media-type-->
                <!--media-type :className="'grid-ideas-media'" :obj="item.cover" :testvid="index" :dynAlt="item.title[lang].name" v-if="offSet.last >= index" :thumb="true" :full="true">  </media-type-->
                        </div>


                        <div class="info-case">
                          <h4>{{item.client[0].name}}</h4>
                          <h3>{{item.title[0].name}}</h3>


                        </div>

                      </div>

                    </a>
                    </transition-group>
                  </div>


                </div>

                <div class="content-footer-project" >
                  <footer-nossa :lang="lang" :isMobile="isMobile"></footer-nossa>
                </div>
              </div>
          </template>

          <script>


              import {NavEvents} from "../dataModules/NavEvents";
              import {TweenMax} from "gsap/TweenMax";
              import {EVENTBUS, WP, getDeskProj, setDeskProj} from '../main';
              import WorkProj from "./Modules/WorkProj";
              import HeroWork from "./Modules/HeroWork";
              import FooterNossa from "./FooterNossa";
              import MediaType from "./Modules/MediaType";



              export default {

                  name: 'ideia',
                components: {MediaType, FooterNossa, HeroWork, WorkProj},
                props: ['actRoute', 'isMobile', 'lang'],
                watch: {
                  '$route' (to, from) {


                    this.hasHash(to)
                  }
                },
                computed: {
                  langComp() {
                    return this.lang
                  }
                },
                  data() {
                      return {


                        workData: [],
                        loaded: false,
                        loaded2: false,
                        ready: false,
                        filtersActive:[],
                        dev: false,
                        langs: ['pt', 'en'] ,


                        footerVisited : '',
                        main: {},
                        vFoot: false,
                        tags: [],
                        projects: [],
                        projectsFiltres: [],
                        offSet: {
                          vis: [],
                          tops: [],
                          last: -1
                        },

                      }
                  },

                head: {
                  title: function () {
                    const _this = this;
                    return {
                      inner: 'NOSSA™',   separator: '|',   complement: 'Ideias'
                    }
                  },


                },

                created() {

                    const _this = this;









                   // console.log(_this.workData)


              WP('work', function (response){
                _this.workData = response[0];
                    WP('projects', function (response){

                    //  console.log(response)

                      for(let i = 0; i <= response.length; i++){
                        // console.log(response[i].cover.img);
                      }

                      _this.projects = response;
                      WP('tags', function (response){
                        _this.tags = response;
                        _this.loaded = true;
                     //   _this.init();


                          _this.loaded2 = true;


                          _this.init();
                        });
                      });
                    });






                },
                mounted() {
                  this.ready = true;
                  this.init();
                  //EVENTBUS.$on('AAA', AAA);
                  //EVENTBUS.$emit('AAA', 0);
                  $(window).scrollTop(0);
                  $('body, html').scrollTop(0);


                },

                destroyed() {
                  $( window ).off();


                },

                methods: {

                  resizeMe(){

                  },

                  init() {
                    const _this = this;
                    if(this.loaded && this.ready){

                      _this.hasHash(_this.$route)
                      _this.initScroll();



                      setTimeout(function(){
                        _this.initScroll();
                      }, 300);

                    }
                  },


                  hasHash(route){


                    const _this = this;





                    if(route.hash == ''){

                      _this.initFilters('all');

                    }else{
                      let dec =  decodeURI(route.hash)
                     let _hs =  dec.substr(1)

                      _this.initFilters(_hs);
                    }







                  } ,



                  initScroll(){
                    const _this = this;
                   // console.log(_this.offSet)

                    _this.offSet.tops = [];

                    $('.grid-iideas-item').each(function(i) {


                      _this.offSet.tops.push($(this).offset().top);
                      _this.offSet.vis[i] = false;
                    });
                    //console.log( '--')
                    //console.log( _this.offSet)

                    setTimeout(() =>{



                      $( window ).scroll(function(e) {

                        _this.scrollEvt()
                      });

                      $( window ).resize(function() {
                        _this.reseizeMe();
                      });

                      _this.reseizeMe();
                      _this.scrollEvt();
                     // _this.offSet.last = 1;


                    }, 30)
                  },

                  reseizeMe() {
                    this.scrollEvt()
                  },

                  scrollEvt() {

                    const _this = this;

                    _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();

                    _this.offSet.tops = [];

                    $('.grid-iideas-item').each(function(i){
                      _this.offSet.tops.push($(this).offset().top);
                    });

                    $('.grid-iideas-item').each(function(i){




                      //console.log(_this.offSet.act, _this.offSet.tops[i], _this.offSet.vis[i])

                   //   console.log(_this.offSet.act, _this.offSet.vis[i])
                     // console.log(_this.offSet.tops)
                      //console.log('')
                      //console.log('')
                      if(_this.offSet.act > (_this.offSet.tops[i]  + 1) &&  !_this.offSet.vis[i]) {


                   //     console.log('passou' , i)
                        _this.offSet.last = i;
                        _this.offSet.vis[i] = true;
                      }else{
                      //  console.log('virou', i)
                      }

                    });

                   // console.log( _this.offSet.last)

                   // console.log(_this.offSet.act, _this.offSet.tops)

                    if(_this.offSet.act > ($('.content-footer-project').offset().top  + 20 )  && !_this.vFoot) {

                      _this.vFoot = true;

                      EVENTBUS.$emit('showFooter');
                    }





                  },

                  getDelay(index){

                    let ret = 0;

                    if(index < 4){
                      if(index == 0 || index == 2){
                        ret = 0;
                      }else{
                        ret = 100;
                      }
                    }else{

                    }



                    return ret + 'ms';

                  },


                  setFilterAll(){
                    this.initFilters('all')
                  },

                  setFilter(tag){

                    const _this = this;

                    let hFilter = false;


                    if(this.filtersActive.length == 4 ){
                      _this.filtersActive = [];
                      _this.filtersActive.push(tag);
                    }else{
                      for(let i = 0; i <  _this.filtersActive.length; i++){
                        if(tag  == _this.filtersActive[i]){
                          // console.log(this.filtersActive);
                          this.filtersActive.splice(i, 1);
                          hFilter = true;
                        }else{
                          // this.filtersActive.push(tag);
                        }
                      }

                      if(!hFilter){
                        _this.filtersActive.push(tag);
                      }
                    }





                    _this.pushProjects();
                  //  console.log(_this.filtersActive);

                    _this.scrollEvt();
                    setTimeout(function(){
                      _this.scrollEvt();
                    }, 200);


                  },

                  initFilters(filter){
                    let arrTemp = [];
                    this.projectsFiltres = []
                    this.filtersActive = [];
                    let countCol = 1;
                    let countLine = 0;
                    let arrVid = this.thumbsHasVid();
                   // console.log(filter)




                    if(filter == 'all'){
                      for(let i = 0; i <  this.tags.length; i++){
                        // console.log(this.tags[i].name[this.lang].name)
                        this.filtersActive.push(this.tags[i].name[this.lang].name)
                      }
                     // this.projectsFiltres = this.projects;
                      arrTemp = this.projects;
                    }else{
                      this.filtersActive.push(filter)
                      this.pushProjects();
                    }



                    for(let j = 0; j <  this.projects.length; j++){
                      console.log(this.hasFilter(this.projects[j].tags[0]))

                    }


                    for(let k = 0; k < arrTemp.length; k++){

                      let tempItem = arrTemp[k];

                      //tempItem.push({kabroka  : 'monhasss'});




                      tempItem['hasVideo'] = false;

                      if(k < 4){
                        tempItem['hasVideo'] = true;
                      }else{

                        if(countCol > 3){
                          countCol = 1;
                          countLine ++;
                        }

                        if(arrVid[countLine] === countCol){
                          console.log(countCol)
                          tempItem['hasVideo'] = true;
                        }




                        countCol ++;
                      }




                      this.projectsFiltres.push(tempItem)


                    }


                    //  projectsFiltres

                 //   console.log(this.filtersActive)

                  },


                  pushProjects(){
                    this.projectsFiltres = [];
                    for(let j = 0; j <  this.projects.length; j++){
                      if(this.hasFilter(this.projects[j].tags[0])){
                        this.projectsFiltres.push(this.projects[j])
                      }

                    }


                  },



                  hasFilter(tag){


                    let ret  = false;
                    for(let i = 0; i <  this.filtersActive.length; i++){

                      if(tag.name[this.lang].name == this.filtersActive[i]){
                        ret = true;
                      }
                    }
                    return ret;
                  },


                  goRoute(route){

                    const _this = this;


                    _this.$router.push('project/' + route);
                    //     $('#dragme').hide();



                  },

                  generateRandomIntegerInRange(min, max) {
                    return Math.floor(Math.random() * (max - min + 1)) + min;
                  },

                  thumbsHasVid(){
                    let lastNum = 0;
                    let num = 0;
                    let arr = [];


                    for(let i = 0; i<50; i++){


                      do {
                        num = this.generateRandomIntegerInRange(1,3);
                      }
                      while (lastNum == num);

                      arr.push(num)

                      lastNum = num;
                    }

                    return arr
                  }



                },
              };

          </script>


// WEBPACK FOOTER //
// src/components/Ideia.vue